export const STANDARD_DIMENSIONS = [
  {
    name: 'Category',
    description:
      "The category of the document, such as 'Wildfire Mitigation Plan', 'General Rate Case', 'Community Solar Plan', 'Electric Vehicle Plan', 'General Regulatory Filing - Other', 'Research Paper', etc.",
    type: 'string',
    show_advisor_filter: false
  },
  {
    name: 'Classification',
    description:
      'The BISAC Classification for library filing purposes, including both the coded part and the subheading part.',
    type: 'string',
    show_advisor_filter: false
  },
  {
    name: 'Company',
    description: 'The long form company name as it traditionally appears.',
    type: 'string',
    show_advisor_filter: false
  },
  {
    name: 'Company Initialism',
    description:
      'The abbreviated company name or ticker symbol if available. Ensure consistent naming for company abbreviation name. Use the simplest abbreviation form with no special characters or whitespace.',
    type: 'string',
    show_advisor_filter: false
  },
  {
    name: 'Country',
    description: 'The country that is of primary concern for this document.',
    type: 'string',
    show_advisor_filter: false
  },
  {
    name: 'Date',
    description: 'The date this document was published in the form YYYY-MM-DD.',
    format: 'date',
    type: 'string',
    show_advisor_filter: false
  },
  {
    name: 'Description',
    description: 'A helpful description of the document for someone who might want a quick overview of the document.',
    type: 'string',
    show_advisor_filter: false
  },
  {
    name: 'Docket Number',
    description:
      "A Docket Number is also known as a case number. It is used in courts as a way to track a case. Once a docket number is assigned to a case, it must appear on all papers submitted to the Court. Typically, a docket number is made up of a two-digit number (to signify the year), followed by the case type (either Civ. for civil cases or Cr. for criminal cases), followed by a four- or five- digit case number and followed by the judge's initials in parentheses.",
    type: 'string',
    show_advisor_filter: true
  },
  {
    name: 'Document Type',
    description:
      "The type of the document. Pick from the following choices: ['Public Notice', 'Application to Intervene', 'Rate Application', 'Cost-of-Service Study', 'Rate Design Proposal', 'Testimony', 'Evidence', 'Rebuttal', 'Joint Operating Brief', 'Legal & Procedural', 'Proposed Decision', 'Final Decision']",
    type: 'string',
    show_advisor_filter: false
  },
  {
    name: 'Economic Value',
    description: 'A rough estimate of the investment amounts implied in this document as a dollar figure.',
    type: 'number',
    show_advisor_filter: false
  },
  {
    name: 'Industry',
    description: 'The industry or line of business e.g. Gas, Water, Electric, etc.',
    type: 'string',
    show_advisor_filter: false
  },
  {
    name: 'Motivation',
    description: 'A brief explanation of why this document is being filed.',
    type: 'string',
    show_advisor_filter: false
  },
  {
    name: 'Objectives',
    description: 'The objectives sorted by time horizon.',
    type: 'string',
    show_advisor_filter: false
  },
  {
    name: 'Phase',
    description:
      'Indicate whether this appears to be an initial filing, a follow-up filing, or a response to a filing.',
    type: 'string',
    show_advisor_filter: false
  },
  {
    name: 'Population',
    description: 'A real number estimate of the people potentially affected by this document.',
    type: 'number',
    show_advisor_filter: false
  },
  {
    name: 'Risk Factors',
    description: 'A list of prioritized risk factors laid out in the document',
    type: 'array',
    show_advisor_filter: false
  },
  {
    name: 'Rules',
    description:
      'List, separated by commas, the full citation to the specific rule(s) of law or regulation to which this filing complies.',
    type: 'string',
    show_advisor_filter: false
  },
  {
    name: 'State',
    description: 'The U.S. State that is of primary concern for this document. Use full State name.',
    type: 'string',
    show_advisor_filter: true
  },
  {
    name: 'Summary',
    description: 'A quick summary of the document.',
    type: 'string',
    show_advisor_filter: false
  },
  {
    name: 'Title',
    description: 'The document title.',
    type: 'string',
    show_advisor_filter: false
  },
  {
    name: 'Version',
    description: 'The version of the document. This could be Draft, Final, or any other version the document specifies',
    type: 'string',
    show_advisor_filter: false
  },
  {
    name: 'Year',
    description: 'The year this document was filed.',
    type: 'integer',
    show_advisor_filter: true
  }
];
